import { SvgCommonProperties } from '../../interfaces/svg.interfaces';

export default function EditPencilSvg(props: SvgCommonProperties) {
  return <svg
  xmlns="http://www.w3.org/2000/svg"
  height={props.height}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth={2}
  strokeLinecap="round"
  strokeLinejoin="round"
  className="w-6 h-6"
>
  <path d="M12 20h9" />
  <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
</svg>

}